import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducer'
import { routerMiddleware } from 'connected-react-router'
import saga from './sagas';
import { setupAxiosHandler } from './common/axiosHandler'
export const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory();
const routingMiddleware = routerMiddleware(history);

// redux store
let store = createStore(
    rootReducer(history),
    composeWithDevTools(
      applyMiddleware(sagaMiddleware, routingMiddleware),
    )
);

export default store;

setupAxiosHandler(store);
sagaMiddleware.run(saga);